// extracted by mini-css-extract-plugin
export default {"outerDiv":"MyAddresses_outerDiv__nGE7m"};